export class ImagePreloader {
	constructor(progressCallback, completionCallback) {
		this.progressCallback = progressCallback;
		this.completionCallback = completionCallback;
		this.imgs = [];
		this.loadedImages = {};
		this.currentPrefix = ""
	}
	go() {
		var self = this;
		self.loadedcount = 0;
		self.imghtml = "";

		var noCacheImages = this.imgs.map(function (img) {
			return img;
		});

		this.worker = new Worker(`${process.env.PUBLIC_URL}/image_preload_webworker.js`);
		var count = noCacheImages.length;
		this.worker.onmessage = function(e){

			// eslint-disable-next-line no-unused-vars
			var frag = document.createDocumentFragment(),
			// eslint-disable-next-line no-unused-vars
				onload = function () {
					delete this.onload;
					if (--count === 0) {
						console.log('done')
						if(self.completionCallback){
							self.completionCallback();
						}
					}
					console.log('todo: '+ count);
				};
			if(e.data.method === "completion"){

						if(self.completionCallback){
							self.completionCallback();
						}
				self.imgs.forEach(function (img) {
				});
			} else if (e.data.method === "progress"){
				
				var img = new Image();
				img.onload = function(){
					this.isLoaded = true;
				}
				img.src = e.data.url;
				self.loadedImages[e.data.url] = img;

				if (self.progressCallback) {
					self.progressCallback(e.data.progress);
				}
			}
		};

		this.worker.postMessage(noCacheImages);
	}
	addImage(image) {
		this.addImages(image);
	}
	addImages(images) {
		if(this.imgs == null){
			this.imgs = [];
		}
	
		var parts = images.split(";");
		for(var key in parts){
			if(parts[key]===""){
				continue;
			}
			this.imgs[this.imgs.length] = parts[key];
		}
	}
	addImageArray(images) {
		for (var i = 0; i < images.length; i++) {
			this.addImage(images[i]);
		};
	}
	addImageSequence(prefix,firstFrame,lastFrame,imageExtension,isReversed) {
		this.currentPrefix = prefix
		if (this.imageNameArray==null) {
			this.imageNameArray = [];
		}
		var padBy = 1;
		if (lastFrame > 9) {
			padBy = 2;
		}
		if (lastFrame > 99) {
			padBy = 3;
		}
		if (lastFrame > 999) {
			padBy = 4;
		}
		if (lastFrame > 9999) {
			padBy = 5;
		}
		if(!isReversed){
			for (var i = firstFrame; i <= lastFrame; i++) {
				this.addImage(process.env.PUBLIC_URL+prefix+pad(i,padBy)+"."+imageExtension);
			}
		} else {
			for (i = lastFrame; i >= firstFrame; i--) {
				this.addImage(process.env.PUBLIC_URL+prefix+pad(i,padBy)+"."+imageExtension);
			}
		}
	}
}


function pad(n, width, z) {  z = z || '0';  n = n + '';  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;}
